<div class="dialog-header" data-testid="help-info-dialog">
  <h3 mat-dialog-title class="dialog-title">Helpful Information to Include</h3>
  <button class="close-x" (click)="close()" aria-label="Close dialog" data-testid="help-info-close-btn">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <p class="dialog-intro">
    Providing the following details helps vendors deliver accurate, high-quality translations:
  </p>

  <ul class="info-list">
    <li>
      <strong>Subject-matter context</strong> — Briefly describe the topic or therapeutic area so translators can use the correct terminology.
    </li>
    <li>
      <strong>Glossaries or style guides</strong> — Attach any approved glossaries, term bases, or brand style guides that should be followed.
    </li>
    <li>
      <strong>Reference translations</strong> — Upload previously translated materials for consistency in tone and terminology.
    </li>
    <li>
      <strong>Target audience</strong> — Specify whether the content is for healthcare professionals, patients, regulators, or internal teams.
    </li>
    <li>
      <strong>Brand or product terminology</strong> — List any proprietary names, acronyms, or terms that must remain untranslated or follow specific conventions.
    </li>
    <li>
      <strong>Formatting requirements</strong> — Note any layout, font, or desktop-publishing instructions that vendors should be aware of.
    </li>
    <li>
      <strong>Deadline or urgency notes</strong> — Mention if there is a hard deadline or milestone driving the request timeline.
    </li>
    <li>
      <strong>Regulatory considerations</strong> — Flag any compliance or legal review requirements that apply to the translated content.
    </li>
  </ul>
</mat-dialog-content>
